import { render } from "./IconPlay.vue?vue&type=template&id=6247402c"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconPlay.vue"]])

export default __exports__